import { AuthToken } from "@pcp/core/interfaces";

/**
 * Type alias for Pcp SignalR Group ID to join.
 */
export type PcpSignalrGroupIdentifier = string;

/**
 * Type alias for Azure Communication Services Group Identifier to join.
 */
export type AzureCommunicationGroupIdentifier = string;

/**
 * Token returned from the PCP WebApi
 */
export interface PcpLiveSessionToken {
    aud: string;    // URL
    nameid: string; // GUID
    iss: string;    // URL
    exp: number;    // timestamp
    displayName: string;
    pcpApiToken: AuthToken;
    threadId: string; // Main Chat ThreadId

    /**
     * Group Identifier for PCP SignalR:
     * User will connect to this group identifier on the PCP SignalR Connection.
     * Used for SignalR _and_ as RoomID for Azure Communication Services.
     *
     * TODO: not used yet
     */
    pcpSignalrGroupId: PcpSignalrGroupIdentifier;

    /**
     * Group Identifier for Azure Communication Services:
     * User will join this group in Azure Communication Services.
     */
    azureCommunicationGroupId: AzureCommunicationGroupIdentifier;

    /**
     * Azure Communication Services User ID.
     * This is an independent identifier for ACS and not idenical to the PCP User ID or Cusomer ID.
     *
     * @example 8:acs:b46c5caa-0c5f-499b-ab72-687ac573a407_0000000f-34fb-71b4-34fa-ad3a0d00a06f
     */
    communicationUserId: string;
    azureCommunicationToken: string; // another JWT - but this time from azure
}

export const isPcpLiveSessionToken = (token: object): token is PcpLiveSessionToken => (
    'aud' in token &&
    'nameid' in token &&
    'iss' in token &&
    'exp' in token &&
    'displayName' in token &&
    'communicationUserId' in token &&
    'azureCommunicationToken' in token &&
    'pcpSignalrGroupId' in token &&
    'azureCommunicationGroupId' in token
);
